import { useMutation } from "@tanstack/react-query";
import { UsersAPI } from "../api";

export const useMyselfDetails = () => {
  return useMutation({
    mutationFn: () => UsersAPI.getMyselfDetails(),
    onError: (error) => {
      console.error("Get Myself Details Failed: ", error.response || error);
    },
  });
};

export const useGetAllEmployeesPaginated = () => {
  return useMutation({
    mutationFn: ({ page, pageSize }) =>
      UsersAPI.getAllPaginated({ page, pageSize }),
    onError: (error) => {
      console.error("Get All Employees Failed: ", error.response || error);
    },
  });
};
